export const idTiposProfesionales = {
    MEDICO: 1,
    ENFERMERO: 2,
    NUTRICIONISTA: 3,
    FONOAUDIOLOGO: 4,
    KINESIOLOGO: 5,
    PSICOLOGO: 6,
    ENFERMERO_GUARDIA: 7,
    PSIQUIATRA: 8,
    TERAPISTA_OCUPACIONAL: 9,
    ASISTENTE_SOCIAL: 10,
    REHABILITADOR: 11,
}

export const allowedTypesSaveInfoPaciente = [
    idTiposProfesionales.KINESIOLOGO,
    idTiposProfesionales.PSICOLOGO,
    idTiposProfesionales.PSIQUIATRA,
    idTiposProfesionales.TERAPISTA_OCUPACIONAL,
    idTiposProfesionales.ASISTENTE_SOCIAL,
    idTiposProfesionales.REHABILITADOR
];